module.exports = __webpack_public_path__ + "static/img/icon-p2-6gs.d2f88b77.png";